import React, { useState, useEffect } from 'react'
import { Card, Button, DatePicker, Space, Typography } from 'antd'
import PropTypes from 'prop-types'
import moment from 'moment'
import { getPresets, ISO, RU, formatPeriod } from '../dateUtils'

const { RangePicker } = DatePicker
const { Text } = Typography

// Presets apply immediately on click. Manual calendar selection only stages a
// pending range and is applied when the user presses "Применить".
const FilterBar = ({ applied, onApply }) => {
  const presets = getPresets()
  const [pending, setPending] = useState([
    moment(applied.from, ISO),
    moment(applied.to, ISO)
  ])

  // Keep the picker in sync when a preset changes the applied range.
  useEffect(() => {
    setPending([moment(applied.from, ISO), moment(applied.to, ISO)])
  }, [applied.from, applied.to])

  const activePreset = presets.find(
    p => p.from === applied.from && p.to === applied.to
  )

  const dirty =
    pending &&
    pending[0] &&
    pending[1] &&
    (pending[0].format(ISO) !== applied.from ||
      pending[1].format(ISO) !== applied.to)

  const handleApply = () => {
    if (pending && pending[0] && pending[1]) {
      onApply({ from: pending[0].format(ISO), to: pending[1].format(ISO) })
    }
  }

  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space wrap size={[8, 8]} style={{ marginBottom: 12 }}>
        {presets.map(p => (
          <Button
            key={p.key}
            size="small"
            type={
              activePreset && activePreset.key === p.key ? 'primary' : 'default'
            }
            onClick={() => onApply({ from: p.from, to: p.to })}
          >
            {p.label}
          </Button>
        ))}
      </Space>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          flexWrap: 'wrap'
        }}
      >
        <Text type="secondary">Свой период:</Text>
        <RangePicker
          value={pending}
          onChange={setPending}
          format={RU}
          allowClear={false}
        />
        <Button type="primary" onClick={handleApply} disabled={!dirty}>
          Применить
        </Button>
        <Text type="secondary" style={{ marginLeft: 'auto' }}>
          Показан период: <b>{formatPeriod(applied)}</b>
        </Text>
      </div>
    </Card>
  )
}

FilterBar.propTypes = {
  applied: PropTypes.shape({
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired
  }).isRequired,
  onApply: PropTypes.func.isRequired
}

export default FilterBar
